import { UpdateGraphSettingDataInterface } from "./interfaces";
import GraphContent from "../graph_content";
import { MstGraphType } from "../../../types/types";
import { translate } from "@/main";

export class GraphSettingUpdateFunc {
  public static makeSendData(self: GraphContent) {
    // thresholdSettingsの内容を初期化する
    for (const thresholdSettingKey in self.thresholdSettings) {
      self.thresholdSettings[thresholdSettingKey] = {
        max: {
          enabled: false,
          value: 0
        },
        min: {
          enabled: false,
          value: 0
        }
      };
    }
    // thresholdSettingsをaddThresholdSettingAreaの内容で更新する
    for (const addThresholdSetting of self.addThresholdSettingArea) {
      self.thresholdSettings[addThresholdSetting.addSelectedThresholdKey] =
        JSON.parse(JSON.stringify(addThresholdSetting.addSelectedThreshold));
    }

    const updateData: MstGraphType = {
      user_id: self.userID,
      graph_id: self.graphID,
      lineType: self.lineType,
      authStoreName: self.authStoreName,
      updateInterval: String(self.reloadInterval),
      partitionKey: self.partitionKey,
      partitionKeyType: self.partitionKeyType,
      sortKey: self.sortKey,
      sortKeyType: self.sortKeyType,
      drawRange: self.drawRange,
      targetAttribute:
        self.selectedAttributes === ""
          ? self.targetAttribute
          : self.selectedAttributes,
      targetAttributes: self.targetAttributes,
      targetPartitionKey:
        self.selectedPartitions === ""
          ? self.targetPartitionKey
          : self.selectedPartitions,
      timeFormat: self.timeFormat,
      dataTimezone: self.dataTimezone,
      partitions: self.partitions,
      attributes: self.attributes,
      graphTitle: self.graphTitle,
      mails: self.mails.split(","),
      table: self.tableName,
      threshold: self.threshold,
      thresholdSettings: JSON.stringify(self.thresholdSettings),
      range: self.range,
      graphDateFormat: self.graphDateFormat,
      orgTimeFormat: self.orgTimeFormat,
      changeAlertSwitch: self.changeAlertSwitch === true ? true : false,
      thresholdSettingsList: []
    };
    if (
      self.addThresholdSettingArea.length === 1 &&
      self.addThresholdSettingArea[0].addSelectedThresholdKey === ""
    ) {
      updateData.thresholdSettingsList = [];
    } else {
      updateData.thresholdSettingsList = self.addThresholdSettingArea.map(
        (x) => x.addSelectedThresholdKey
      );
    }
    updateData.mails = GraphSettingUpdateFunc.filterMails(updateData.mails);
    if (updateData.mails.length === 1 && updateData.mails[0] === "") {
      updateData.mails.length = 0;
    }
    return updateData;
  }

  public static checkUpdateData(updateData: MstGraphType): string | boolean {
    const checkTableNameResult = GraphSettingUpdateFunc.checkTableName(
      updateData.table
    );
    if (!checkTableNameResult.result) {
      return checkTableNameResult.msg;
    }
    const checkPartitionResult = GraphSettingUpdateFunc.checkPartition(
      updateData.partitionKey
    );
    if (!checkPartitionResult.result) {
      return checkPartitionResult.msg;
    }
    const checkSortKeyResult = GraphSettingUpdateFunc.checkSortKey(
      updateData.sortKey
    );
    if (!checkSortKeyResult.result) {
      return checkSortKeyResult.msg;
    }
    const checkThresholdResult = GraphSettingUpdateFunc.checkThreshold(
      updateData.threshold
    );
    if (!checkThresholdResult.result) {
      return checkThresholdResult.msg;
    }
    const checkMailsResult = GraphSettingUpdateFunc.checkMails(
      updateData.mails
    );
    if (!checkMailsResult.result) {
      return checkMailsResult.msg;
    }
    const checkIntervalResult = GraphSettingUpdateFunc.checkUpdateInterval(
      updateData.updateInterval
    );
    if (!checkIntervalResult.result) {
      return checkIntervalResult.msg;
    }
    const checkDrawRangeResult = GraphSettingUpdateFunc.checkDrawRange(
      updateData.drawRange
    );
    if (!checkDrawRangeResult.result) {
      return checkDrawRangeResult.msg;
    }
    const checkRangeResult = GraphSettingUpdateFunc.checkRange(
      updateData.range
    );
    if (!checkRangeResult.result) {
      return checkRangeResult.msg;
    }
    const checkGraphDateFormat = GraphSettingUpdateFunc.checkGraphDateFormat(
      updateData.graphDateFormat
    );
    if (!checkGraphDateFormat.result) {
      return checkGraphDateFormat.msg;
    }
    const checkTargetAttribute = GraphSettingUpdateFunc.checkTargetAttribute(
      updateData.targetAttribute
    );
    if (!checkTargetAttribute.result) {
      // return checkTargetAttribute.msg;
      updateData.targetAttribute = null;
    }
    const checkTargetPartitionKey = GraphSettingUpdateFunc.checkTargetPartitionKey(
      updateData.targetPartitionKey
    );
    if (!checkTargetPartitionKey.result) {
      // return checkTargetPartitionKey.msg;
      updateData.targetPartitionKey = "-";
    }

    return true;
  }

  private static filterMails(mails: string[]) {
    return mails.filter(function(x, i, self) {
      return self.indexOf(x) === i;
    });
  }

  private static checkMails(mails: UpdateGraphSettingDataInterface["mails"]) {
    const results: boolean[] = mails.map((mail: string) => {
      return (
        mail.match(
          /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i
        ) === null
      );
    });
    if (mails.length === 1 && mails[0] === "") {
      return { result: true };
    } else if (results.indexOf(true) >= 0) {
      return { result: false, msg: `${translate("message.invalidEmail")}` };
    } else if (mails.length > 5) {
      return {
        result: false,
        msg: `${translate("youCanRegisterUpTo5EmailAddresses")}`
      };
    } else {
      return { result: true };
    }
  }

  private static checkThreshold(
    threshold: UpdateGraphSettingDataInterface["threshold"]
  ) {
    if (
      threshold.min.enabled &&
      threshold.max.enabled &&
      threshold.max.value <= threshold.min.value
    ) {
      return {
        result: false,
        msg: `${translate(
          "message.makeSureHighThresholdIsGreaterThanThatOfLowThreshold"
        )}`
      };
    } else {
      return { result: true };
    }
  }

  private static checkUpdateInterval(interval: MstGraphType["updateInterval"]) {
    if (Number(interval) <= 0) {
      return {
        result: false,
        msg: `${translate("message.makeSureReloadIntervalIsLongerThan0Sec")}`
      };
    } else {
      return { result: true };
    }
  }

  private static checkTableName(
    tableName: UpdateGraphSettingDataInterface["table"]
  ) {
    if (tableName === "") {
      return { result: false, msg: `${translate("message.enterTableName")}` };
    } else {
      return { result: true };
    }
  }

  private static checkPartition(
    partition: UpdateGraphSettingDataInterface["partitionKey"]
  ) {
    if (partition === "") {
      return {
        result: false,
        msg: `${translate("message.enterPartitionKey")}`
      };
    } else {
      return { result: true };
    }
  }

  private static checkSortKey(
    sortKey: UpdateGraphSettingDataInterface["sortKey"]
  ) {
    if (sortKey === "") {
      return { result: false, msg: `${translate("message.enterSortKey")}` };
    } else {
      return { result: true };
    }
  }

  private static checkRange(range: UpdateGraphSettingDataInterface["range"]) {
    if (range.enabled && range.max <= range.min) {
      return {
        result: false,
        msg: `${translate(
          "message.makeSureHighRangeIsGreaterThanThatOfLowRange"
        )}`
      };
    } else {
      return { result: true };
    }
  }

  private static checkDrawRange(
    range: UpdateGraphSettingDataInterface["drawRange"]
  ) {
    if (range === "") {
      return {
        result: false,
        msg: `${translate("message.selectPlottingRange")}`
      };
    } else {
      return { result: true };
    }
  }

  private static checkGraphDateFormat(
    format: UpdateGraphSettingDataInterface["graphDateFormat"]
  ) {
    if (format === "") {
      return {
        result: false,
        msg: `${translate("message.graphDisplaySelectTimeFormatToDisplay")}`
      };
    } else {
      return { result: true };
    }
  }

  private static checkTargetAttribute(
    targetAttribute: UpdateGraphSettingDataInterface["targetAttribute"]
  ) {
    if (targetAttribute === "") {
      return {
        result: false,
        msg: `${translate("message.graphDisplaySelectTargetKey")}`
      };
    } else {
      return { result: true };
    }
  }

  private static checkTargetPartitionKey(
    targetPartitionKey: UpdateGraphSettingDataInterface["targetPartitionKey"]
  ) {
    if (targetPartitionKey === "") {
      return {
        result: false,
        msg: `${translate("message.graphDisplaySelectPartitionKey")}`
      };
    } else {
      return { result: true };
    }
  }
}
